var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.obj_to_null(this.categ)
    ? _c(
        "div",
        { staticClass: "categ_info" },
        [
          _c("info_field", {
            attrs: {
              f_uniq: "ct",
              f_type: "title",
              f_title: _vm.__t("NAME"),
              is_disabled: _vm.is_disabled,
              f_val: _vm.cur_categ.title,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cid",
              f_title: _vm.__t("UNIQ_GO_CODE"),
              f_val: _vm.cur_categ.id.toString(),
            },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cuid",
              f_title: _vm.__t("UNIQ_PROV_CODE"),
              f_val: _vm.cur_categ.uniq_id,
            },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_title: _vm.__t("LOAD_FROM"),
              f_icon: "fa-sync",
              f_val: _vm.prov_name,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group mt-2" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "description" } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.__t("INTRO_CATEG")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-group flex-nowrap" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cur_categ.introcontent,
                    expression: "cur_categ.introcontent",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "description" },
                domProps: { value: _vm.cur_categ.introcontent },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.cur_categ, "introcontent", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "name-f" } },
              [_vm._v(_vm._s(_vm.__t("DATE_CREATE")))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-group" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cur_categ.added,
                    expression: "cur_categ.added",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "name-f", disabled: "" },
                domProps: { value: _vm.cur_categ.added },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.cur_categ, "added", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cur_categ.updateAt,
                    expression: "cur_categ.updateAt",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "name-l", disabled: "" },
                domProps: { value: _vm.cur_categ.updateAt },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.cur_categ, "updateAt", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text text-success" }, [
        _c("i", { staticClass: "fal fa-calendar-edit fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }